// extracted by mini-css-extract-plugin
export default {"projectListBody":"ProjectsList_projectListBody__JGoLQ","mobileImgContainer":"ProjectsList_mobileImgContainer__mJaXY"};